import Raven from "raven-js";

export default function configureSentry(sentryDSN) {
  if (sentryDSN && process.env.NODE_ENV === "production") {
    Raven.config(sentryDSN).install();
  }
}
